export default "__VITE_ASSET__BM$BD3r6__"